function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4 7.2c0-.77.257-2.104 1.056-3.217C5.817 2.922 7.107 2 9.36 2c2.28 0 3.699.891 4.566 1.95.901 1.098 1.242 2.42 1.242 3.25 0 .933-.247 1.717-.666 2.375l-.001.002-3.89 6.125a1 1 0 001.688 1.072l3.89-6.124c.627-.985.979-2.143.979-3.45 0-1.262-.482-3.04-1.695-4.519C14.227 1.163 12.242 0 9.359 0c-2.91 0-4.8 1.244-5.928 2.817C2.341 4.336 2 6.1 2 7.2c0 1.25.271 2.604 1.277 4.194l.015.023 5.461 8.142a1 1 0 001.66-1.114l-5.453-8.13C4.177 9.071 4 8.096 4 7.2zm7.45.074a1.864 1.864 0 01-1.866 1.862 1.864 1.864 0 01-1.867-1.862c0-1.025.833-1.86 1.867-1.86 1.033 0 1.866.835 1.866 1.86zm1.5 0a3.364 3.364 0 01-3.366 3.362 3.364 3.364 0 01-3.367-3.362 3.364 3.364 0 013.367-3.36 3.364 3.364 0 013.366 3.36z",
  fill: "currentColor"
});

function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none"
  }, props), _ref);
}

export default "/app/dist/assets/pin.svg";
export { SvgPin as ReactComponent };